@if (travelAdvice) {
  <div>
    <div class="announcement_labels">
      <h2 class="announcement_header first_header" i18n="@@announcementsTravelAdvice">
        Travel Advice
      </h2>
    </div>
    <div class="travel_advice advice_only">
      <div class="travel-advice-message" i18n="@@DueToTheFrequencyOfChanges">
        Due to the frequency of changes in FCO advice on international travel, we highly recommend
        visiting their website for the most up to date travel advice for
        {{ travelAdvice.country }}
      </div>
      <a
        class="more_info"
        target="_blank"
        href="{{ travelAdvice.link }}"
        [attr.aria-label]="'View travel advice for ' + travelAdvice.country + ' (opens in new tab)'"
        i18n="@@announcementsMoreInfo"
        >More Info</a
      >
    </div>
  </div>
}
